import { render } from "./NavBarUserMenu.vue?vue&type=template&id=a89deca8&scoped=true&ts=true"
import script from "./NavBarUserMenu.vue?vue&type=script&lang=ts"
export * from "./NavBarUserMenu.vue?vue&type=script&lang=ts"

import "./NavBarUserMenu.vue?vue&type=style&index=0&id=a89deca8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89deca8"]])

export default __exports__